// removed by extract-text-webpack-plugin
module.exports = {"container":"YfTs54bcfXWsGZ1yNKLzR"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Organizations/Layout/styles.css
// module id = 2984
// module chunks = 0